import React, { useState, useRef, useEffect } from "react";
import styles from "./NEETSyllabus.module.css";

import Chatbot from '../../components/chatbot';
import SocialSidebar from "../../components/SocialSideBar";
import { storage } from '../../firebase';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { FaDownload } from 'react-icons/fa';
import { neetSyllabusData as syllabusData } from '../../data/neetSyllabusData';

const _unused = {
  physics: [
    { chapter: "PHYSICS AND MEASUREMENT", y2025: "Units of measurements; System of Units; SI units; fundamental and derived units; least count; significant figures; Errors in measurements; Dimensions of physical quantities; dimensional analysis and its applications.", y2024: "Same as 2025", y2023: "Same (except earlier more emphasis on ‘accuracy and precision of instruments’, etc.)." },
    { chapter: "KINEMATICS", y2025: "The frame of reference; motion in a straight line; position-time graph; speed & velocity; acceleration; uniformly accelerated motion; relative velocity; motion in a plane; projectile motion; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "LAWS OF MOTION", y2025: "Force and inertia; Newton’s laws; momentum; impulse; conservation of linear momentum; friction (static, kinetic, rolling); etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "WORK, ENERGY AND POWER", y2025: "Work done by constant and variable forces; kinetic & potential energy; work-energy theorem; power; conservation of mechanical energy; collisions (elastic, inelastic).", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ROTATIONAL MOTION", y2025: "Centre of mass; moment of force (torque); angular momentum; moment of inertia; rigid body rotation; parallel & perpendicular axes theorem; equilibrium of rigid bodies; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "GRAVITATION", y2025: "Universal law of gravitation; acceleration due to gravity; variation with altitude / depth; Kepler’s laws; gravitational potential energy; escape velocity; orbital velocity; satellites.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "PROPERTIES OF SOLIDS AND LIQUIDS / BULK MATTER", y2025: "Elastic behavior; stress-strain; Hooke’s law; viscosity; flow of fluids; pressure due to fluid; buoyancy; surface tension; etc.", y2024: "Same but some subtopics trimmed/deleted in 2025 (e.g. some detailed instrumentation / derivations).", y2023: "Same generally" },
    { chapter: "THERMODYNAMICS", y2025: "Thermal equilibrium & temperature (Zeroth law); heat, work, internal energy; First law; reversible & irreversible processes; Second law; heat engines, refrigerators.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "KINETIC THEORY OF GASES", y2025: "Equation of state of a perfect gas; kinetic theory: assumptions; pressure; kinetic interpretation of temperature; degrees of freedom; mean free path; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "OSCILLATIONS AND WAVES", y2025: "Periodic motion; simple harmonic motion; oscillation of spring; pendulum; energy in SHM; wave motion; progressive & standing waves; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ELECTROSTATICS", y2025: "Electric charges; Coulomb’s law; superposition; electric field & lines; electric flux & Gauss’s law; electric potential; equipotential surfaces; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "CURRENT ELECTRICITY", y2025: "Electric current; Ohm’s law; V-I characteristics; drift velocity; resistance; internal resistance; Kirchhoff’s laws; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "MAGNETIC EFFECTS OF CURRENT AND MAGNETISM", y2025: "Magnetic field due to current; Ampere’s law; force on current in magnetic field; moving charges; magnetic dipoles; Earth’s magnetic field; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ELECTROMAGNETIC INDUCTION & ALTERNATING CURRENTS", y2025: "Faraday’s law; Lenz’s law; induced emf; self & mutual inductance; AC; reactance; impedance; resonance in LCR circuits; power in AC circuits; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ELECTROMAGNETIC WAVES", y2025: "Displacement current; electromagnetic waves & their characteristics; spectrum etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "OPTICS", y2025: "Reflection; refraction; lenses; mirrors; dispersion; total internal reflection; prism; wave optics: interference, diffraction; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "DUAL NATURE OF MATTER AND RADIATION", y2025: "Photoelectric effect; Einstein’s photoelectric equation; matter waves; de Broglie relation; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ATOMS AND NUCLEI", y2025: "Atomic models (Bohr, Rutherford); isotopes; radioactivity; nuclear decay; binding energy; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ELECTRONIC DEVICES", y2025: "Semiconductors; diodes; Zener diode; LEDs, photodiode; transistor basics; logic gates; etc.", y2024: "Same as 2025", y2023: "Same" },
  ],
  chemistry: [
    { chapter: "SOME BASIC CONCEPTS IN CHEMISTRY", y2025: "Matter; Dalton’s atomic theory; mole concept; chemical equations; stoichiometry; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ATOMIC STRUCTURE", y2025: "Structure of atom; quantum mechanical model; orbitals; quantum numbers; electronic configuration; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "CHEMICAL BONDING & MOLECULAR STRUCTURE", y2025: "Ionic, covalent bonds; VSEPR; hybridisation; molecular orbital theory; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "THERMODYNAMICS", y2025: "First & Second law; enthalpy, entropy; spontaneity; Gibbs free energy etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "SOLUTIONS", y2025: "Concentration terms; ideal/non-ideal solutions; colligative properties; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "EQUILIBRIUM", y2025: "Chemical and ionic equilibrium; Le Chatelier’s principle; Kc, Kp; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "REDOX REACTIONS & ELECTROCHEMISTRY", y2025: "Oxidation numbers; redox reactions; galvanic & electrolytic cells; Nernst equation etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "CHEMICAL KINETICS", y2025: "Rate of reaction; order & molecularity; rate laws; activation energy etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "CLASSIFICATION OF ELEMENTS & PERIODICITY", y2025: "Periodic table; trends in properties; groups s, p, d, f blocks etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "P-BLOCK ELEMENTS", y2025: "Group 13-18 elements; general properties.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "D- & F- BLOCK ELEMENTS", y2025: "Transition elements; inner transition elements; properties etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "COORDINATION COMPOUNDS", y2025: "Coordination compounds: naming, ligands, chelation, isomerism etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "PURIFICATION & CHARACTERISATION OF ORGANIC COMPOUNDS", y2025: "Methods of purification (distillation, etc.); qualitative tests; characterisation by functional groups etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "SOME BASIC PRINCIPLES OF ORGANIC CHEMISTRY", y2025: "Tetravalency of carbon; isomerism; reaction types; nomenclature; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "HYDROCARBONS", y2025: "Alkanes, alkenes, alkynes; preparation; properties; reactions; aromatic hydrocarbons etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ORGANIC COMPOUNDS CONTAINING HALOGENS", y2025: "Haloalkanes, haloarenes: methods of preparation, reactions etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ORGANIC COMPOUNDS CONTAINING OXYGEN", y2025: "Alcohols, phenols, ethers, aldehydes, ketones, carboxylic acids: preparation, properties, reactions etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ORGANIC COMPOUNDS CONTAINING NITROGEN", y2025: "Amines, diazonium salts: preparation; properties; reactions etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "BIOMOLECULES", y2025: "Carbohydrates, proteins, vitamins, nucleic acids; roles etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "PRINCIPLES RELATED TO PRACTICAL CHEMISTRY", y2025: "Qualitative and quantitative analysis; titrations; experiment-based understanding; etc.", y2024: "Same as 2025", y2023: "Same" },
  ],
  biology: [
    { chapter: "DIVERSITY IN LIVING WORLD", y2025: "Taxonomic categories; biological classification; plant & animal kingdoms; etc. (with some deletions: e.g. ‘three domains of life’, tools for taxonomy, detailed angiosperm classification detailed)’", y2024: "Same major except deletions that were introduced in 2025", y2023: "Full coverage of earlier topics" },
    { chapter: "STRUCTURAL ORGANISATION IN ANIMALS & PLANTS", y2025: "Morphology, anatomy of plants; tissues; organs in animals; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "CELL STRUCTURE & FUNCTION", y2025: "Cell: structure; ultrastructure; cell cycle; cell division; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "PLANT PHYSIOLOGY", y2025: "Photosynthesis; respiration; plant nutrition; transport; growth; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "HUMAN PHYSIOLOGY", y2025: "Nutrition; digestion; breathing & exchange; body fluids & circulation; excretion; control & coordination; reproduction; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "REPRODUCTION", y2025: "Reproductive systems; sexual & asexual reproduction; developmental biology; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "GENETICS & EVOLUTION", y2025: "Mendelian inheritance; molecular basis of inheritance; evolution; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "BIOLOGY & HUMAN WELFARE", y2025: "Human health; disease; prevention; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "BIOTECHNOLOGY & ITS APPLICATIONS", y2025: "Principles & processes; applications; etc.", y2024: "Same as 2025", y2023: "Same" },
    { chapter: "ECOLOGY & ENVIRONMENT", y2025: "Ecosystems; biodiversity; environmental issues; etc.", y2024: "Same as 2025", y2023: "Same" },
  ]
};

const SyllabusTable = ({ data }) => (
  <div className={styles['table-container']}>
    <table className={styles['syllabus-table']}>
      <thead>
        <tr>
          <th>Chapter Name</th>
          <th>NEET 2025</th>
          <th>NEET 2024 Extra</th>
          <th>NEET 2023 Extra</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.chapter}</td>
            <td>{item.y2025}</td>
            <td>{item.y2024}</td>
            <td>{item.y2023}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const NEETSyllabus = () => {
  const [activeTab, setActiveTab] = useState("physics");
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabsRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const tabs = [
    { id: "physics", label: "Physics" },
    { id: "chemistry", label: "Chemistry" },
    { id: "biology", label: "Biology" },
  ];

  useEffect(() => {
    const activeTabIndex = tabs.findIndex((tab) => tab.id === activeTab);
    const activeTabElement = tabsRef.current?.children[activeTabIndex];
    if (activeTabElement) {
      setIndicatorStyle({ left: activeTabElement.offsetLeft, width: activeTabElement.offsetWidth });
    }
  }, [activeTab]);

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading(true);
    try {
      const folderRef = ref(storage, 'materials/syllabus/neet');
      const res = await listAll(folderRef);
      const pdfs = res.items.filter(i => /\.pdf$/i.test(i.name));
      if (pdfs.length === 0) { alert('No PDF found.'); return; }
      const url = await getDownloadURL(pdfs[0]);
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'NEET_Syllabus.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (e) { console.error(e); }
    finally { setDownloading(false); }
  };

  return (
    <div className={styles['syllabus-container']}>
      <Chatbot /> 
      <SocialSidebar />
      <header className={styles['syllabus-header']}>
        <h1>
          <span role="img" aria-label="Syllabus icon">📋</span>
          <span className={styles['gradient-text']}>
            NEET Syllabus 2025 
          </span>
        </h1>
        <p>Complete Syllabus Comparison (2025 vs 2024 vs 2023)</p>
        <div className={styles.dlBtnGroup}>
          <button
            onClick={handleDownload}
            disabled={downloading}
            className={styles.dlBtn}
          >
            {downloading
              ? <><span className={styles.spinner} /> Downloading...</>
              : <><FaDownload /> Download NEET Syllabus {new Date().getFullYear()}</>}
          </button>
        </div>
      </header>

      <div className={styles['syllabus-tabs-container']}>
        <div className={styles['syllabus-tabs']} ref={tabsRef}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={activeTab === tab.id ? `${styles.tab} ${styles.active}` : styles.tab}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
          <span className={styles['tab-indicator']} style={indicatorStyle} />
        </div>
      </div>

      <SyllabusTable data={syllabusData[activeTab]} />
    </div>
  );
};

export default NEETSyllabus;
